export default "__VITE_PUBLIC_ASSET__a81dae02__"